import config from '../../config'
import { DELETE_GROUP, DELETE_GROUP_REQUEST, DELETE_GROUP_FROM_ENTITY_STACK } from './constants'

export function deleteGroup(groupId) {
    return {
        type: DELETE_GROUP,
        data: {
            groupId,
        },
    }
}

export function deleteGroupRequest(groupId) {
    return {
        type: DELETE_GROUP_REQUEST,
        payload: {
            ...config.api.groupStack.deleteGroup,
            qs: {
                id: groupId,
            },
        },
    }
}

export function deleteGroupFromEntityStack(groupId) {
    return {
        type: DELETE_GROUP_FROM_ENTITY_STACK,
        data: {
            groupId,
        },
    }
}
